"use strict";
// source: https://github.com/lodash/lodash/blob/master/.internal/unicodeToArray.js
Object.defineProperty(exports, "__esModule", { value: true });
/** Used to compose unicode character classes. */
var rsAstralRange = "\\ud800-\\udfff";
var rsComboMarksRange = "\\u0300-\\u036f";
var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
var rsComboSymbolsRange = "\\u20d0-\\u20ff";
var rsComboMarksExtendedRange = "\\u1ab0-\\u1aff";
var rsComboMarksSupplementRange = "\\u1dc0-\\u1dff";
var rsComboRange = rsComboMarksRange +
    reComboHalfMarksRange +
    rsComboSymbolsRange +
    rsComboMarksExtendedRange +
    rsComboMarksSupplementRange;
var rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */
var rsAstral = "[".concat(rsAstralRange, "]");
var rsCombo = "[".concat(rsComboRange, "]");
var rsFitz = "\\ud83c[\\udffb-\\udfff]";
var rsModifier = "(?:".concat(rsCombo, "|").concat(rsFitz, ")");
var rsNonAstral = "[^".concat(rsAstralRange, "]");
var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
var rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */
var reOptMod = "".concat(rsModifier, "?");
var rsOptVar = "[".concat(rsVarRange, "]?");
var rsOptJoin = "(?:".concat(rsZWJ, "(?:").concat([rsNonAstral, rsRegional, rsSurrPair].join("|"), ")").concat(rsOptVar + reOptMod, ")*");
var rsSeq = rsOptVar + reOptMod + rsOptJoin;
var rsNonAstralCombo = "".concat(rsNonAstral).concat(rsCombo, "?");
var rsSymbol = "(?:".concat([
    rsNonAstralCombo,
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral,
].join("|"), ")");
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
// eslint-disable-next-line no-misleading-character-class
var reUnicode = RegExp("".concat(rsFitz, "(?=").concat(rsFitz, ")|").concat(rsSymbol + rsSeq), "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @example
 * ```ts
 *  unicodeToArray('🙇‍♂️🤩😭'); // ['🙇‍♂️','🤩','😭'];
 * ```
 */
function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
exports.default = unicodeToArray;
//# sourceMappingURL=unicodeToArray.js.map